<template>
  <v-container fluid :class="this.currentEvent == null ? 'fill-height' : ''">
    <v-row v-if="currentSpeaker == null">
      <v-col>
        <Loading/>
      </v-col>
    </v-row>
    <v-row align="center" v-else justify="center" class="mx-0">
      <v-col cols="12">
        <v-breadcrumbs :items="breadCrumbItems" large>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
                :disabled="item.disabled"
                :class="[
                'text-capitalize px-0',
                {
                  'cursor-pointer':
                    item.routeName != $route.name && !item.disabled,
                },
              ]"
                @click="handleRoute(item)"
            >
              <div
                  :class="[
                  item.routeName != $route.name && !item.disabled
                    ? 'primary--text'
                    : 'grey--text',
                  'text-subtitle ',
                ]"
              >
                {{ item.text }}
              </div>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <v-card outlined min-height="110vh" class="px-8 py-4">
          <v-card-title>{{
              this.currentSpeaker.firstName + " " + this.currentSpeaker.lastName
            }} <v-chip class="ml-4">{{ speakerStatus }}</v-chip>
          </v-card-title>
          <v-card-text>
            <template>
              <v-tabs v-model="tab"
                      active-class="primary--text"
              >
                <v-tab active-class="primary--text" class="text-capitalize" v-for="item in items" :key="item.tab">
                  {{ item.text }}
                </v-tab>
              </v-tabs>
              <v-divider class="pb-6">
              </v-divider>
              <v-row>
                <v-col :cols="9">
                  <v-tabs-items v-model="tab">
                    <v-tab-item v-for="item in items" :key="item.tab">
                      <component v-bind:is="item.content" :currentSponsor="currentSpeaker"></component>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>

                <v-col cols="3">
                  <div class="float-right parent">
                    <v-row align="center" justify="center" class="py-8">
                      <div class="pb-4">
                        <v-btn
                            v-if="currentSpeaker.email && speakerStatus !== 'Joined'"
                            width="150"
                            color="primary"
                            outlined
                            large
                            class="text-body-1 fixed btn mr-4"
                            :disabled="isSaveDisabled"
                            @click="sendInvitationEmail(currentSpeaker)">
                          Send Invitation
                        </v-btn>
                      </div>
                      <div class="pb-4">
                      <v-btn
                          width="150"
                          color="primary"
                          depressed
                          large
                          class="text-body-1 fixed btn"
                          :disabled="isSaveDisabled"
                          @click="handleSave">
                        Save
                      </v-btn>
                      </div>
                    </v-row>
                    <SpeakerPreview :speaker="currentSpeaker"
                                    height="480"
                                    maxHeight="480"
                    />
                  </div>
                </v-col>
              </v-row>
            </template>
          </v-card-text>
        </v-card></v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import Loading from "@/components/Loading.vue";
import Speaker from "@/models/Speaker";
import EditSpeakerDetails from "@/components/MultiConnect/Session/Speakers/EditSpeakerDetails.vue";
import EditSpeakerSocials from "@/components/MultiConnect/Session/Speakers/EditSpeakerSocials.vue";
import Event from "@/models/Event";
import SpeakerPreview from "@/components/MultiConnect/Session/Speakers/SpeakerPreview.vue";
import Attendee from "@/models/Attendee";
import {eventDocRef, speakerDocRef, updateSpeakerDoc} from "@/shared/firebase_utils";
import {onSnapshot} from "firebase/firestore";

let uuid = require("uuid");


export default {
  name: "EditSpeakers",
  components: {SpeakerPreview, Loading},
  data() {
    return {
      tab:0,
      items: [
        {tab: 0, text: 'Speaker Details', content: EditSpeakerDetails},
        {tab: 1, text: 'Socials', content: EditSpeakerSocials},
      ],
      unsubscribeSpeakerSnapshot: null,
      unsubscribeEventsSnapshot: null,
      unsubscribeSubEventsSnapshot: null,
      unsubscribeSessionSnapshot: null,
      eventId: "",
      subEventId: "",
      sessionId: "",
      speakerId: "",
    }
  },
  methods: {
    async sendInvitationEmail(speaker) {
      await this.handleSave();
      try{
        console.log("Yash: speaker", speaker);

        this.showSnackbar({ show: true, text: "Sending invitation email...", timeout: 0 });

          let invitee = {};
          let invitationLink = "";
          const inviteeIndex = this.currentEvent.invitees.findIndex((element) => element.speakerId === speaker.speakerId);
          if (inviteeIndex != -1) {
            console.log("Invitee already exists");
            invitee = this.currentEvent.invitees[inviteeIndex];

          } 
        else {
            console.log("Invitee does not exist");
            console.log("Creating new invitee...")
            invitee = new Attendee({
              email: speaker.email,
              firstName: speaker.firstName,
              lastName: speaker.lastName,
              attendeeId: uuid.v4(),
              invitedAt: new Date(),
              associatedSpeakerSessions: speaker.associatedSpeakerSessions,
              associatedSubEvents: [this.currentSubEvent.id],
              uid: uuid.v4(),
              accessToken: uuid.v4(),
              isSpeaker: true,
              speakerId: speaker.speakerId,
            });
            console.log("Generating private link...")
            await invitee.generatePrivateLink(
                this.currentEvent.id,
                this.currentEvent.name
            );
            console.log("Adding invitee to event...")
            this.currentEvent.invitees.unshift(invitee);
            console.log("Saving event...");
            this.currentEvent.save();
        }
        invitationLink = invitee.dynamicLink;
        console.log("Speaker invitation dynamic link: ", invitee.dynamicLink);
        console.log("Sending invitation email...");
        let result = await invitee.sendInvitation(
          this.currentEvent.linkPrivacy,
          invitationLink,
          this.currentEvent.name,
          this.userProfile.firstName,
          this.userProfile.lastName,
          this.currentEvent.hostName
        );
        
        // speaker.status = "Invited";
        // await speaker.updateSpeaker(this.speakers, this.currentEvent.id, false);
       
        const isSuccess =  result.data.success;
        if (isSuccess) {
          await updateSpeakerDoc(speaker.speakerId, {status: "Invited"});
        }
        console.log("Invitation email cloud function called. Success", isSuccess);
          let snackbarText = isSuccess
            ? "Invitation Sent Successfully!"
            : "Failed to Send Invitation, please try again";
          await this.showSnackbar({ show: true, text: snackbarText });
      } catch (e) {
        console.log("Error sending invitation email", e);
        await this.showSnackbar({ show: true, text: "Failed to Send Invitation, please try again" });
      }
    },
    ...mapActions(["clearCurrentSpeaker", "setCurrentEvent", "setCurrentSubEvent", "setCurrentSession", "setCurrentSpeaker", "clearCurrentSession", "clearCurrentSubEvent", "clearCurrentEvent", "showSnackbar"]),
    handleRoute(item) {
      if (!item.disabled) {
        let route = {name: item.routeName, params: item.params};
        if (item.query) {
          route.query = item.query;
        }
        console.log("route", route);
        this.$router.push(route);
      }
    },
    isValid(value) {
      return value!=undefined && value != "";
    },
    async handleSave() {
      console.log(this.currentEvent.speakers);
      console.log(this.eventId);
      await this.currentSpeaker.updateSpeaker(this.currentEvent.speakers, this.eventId);
      await this.showSnackbar({ show: true, text: "Saved successfully!" });
    }
  },
  created() {
    this.eventId = this.$route.params.eventId;
    this.subEventId = this.$route.params.subEventId;
    this.sessionId = this.$route.params.sessionId;
    this.speakerId = this.$route.params.speakerId;
    //Get event doc from firestore

    this.unsubscribeEventsSnapshot = onSnapshot(
            eventDocRef(this.eventId),
            async (documentSnapshot) => {
          //Event exists in firestore
          if (documentSnapshot.data() != undefined) {
            let newEvent = Event.fromFireStore(documentSnapshot);

            // Update the current tab
            if (this.currentEvent != null) {
              newEvent.currentTab = this.currentEvent.currentTab;
            }

            await this.setCurrentEvent(newEvent);
          } else {
            console.log("event document does not exist in Fs");
          }
        });

    //Get sub-event doc from Firestore
    this.unsubscribeSubEventsSnapshot = onSnapshot(
        eventDocRef(this.subEventId),
        async (documentSnapshot) => {
          //Sub-Event exists in firestore
          if (documentSnapshot.data() != undefined) {
            console.log("event is defined");
            let newSubEvent = Event.fromFireStore(documentSnapshot);

            // Update the current tab
            if (this.currentSubEvent != null) {
              newSubEvent.currentTab = this.currentSubEvent.currentTab;
            }

            await this.setCurrentSubEvent(newSubEvent);
          } else {
            console.log("sub-event document does not exist in Fs");
          }
        });
    this.unsubscribeSessionSnapshot = onSnapshot(
        eventDocRef(this.sessionId),
        async (documentSnapshot) => {
          //Sub-Event exists in firestore
          if (documentSnapshot.data() != undefined) {
            console.log("event is defined");
            let newSession = Event.fromFireStore(documentSnapshot);

            // Update the current tab
            if (this.currentSubEvent != null) {
              newSession.currentTab = this.currentSubEvent.currentTab;
            }
            await this.setCurrentSession(newSession);
          } else {
            console.log("session document does not exist in Fs");
          }
        });
    this.unsubscribeSpeakerSnapshot = onSnapshot(
            speakerDocRef(this.speakerId),
            async(documentSnapshot) => {
          if (documentSnapshot.data() != undefined) {
            console.log("Snapshot",documentSnapshot.data());
            const speaker = Speaker.fromObject(documentSnapshot.data());

            await this.setCurrentSpeaker(speaker);
          } else {
            console.log("speaker document does not exist in Fs");
          }
        });

  },
  destroyed() {
    this.clearCurrentSpeaker();
    this.unsubscribeSpeakerSnapshot();
    this.clearCurrentEvent();
    this.unsubscribeEventsSnapshot();
    this.clearCurrentSubEvent();
    this.unsubscribeSubEventsSnapshot();
    this.clearCurrentSession();
    this.unsubscribeSessionSnapshot();
  },
  computed: {
    ...mapGetters(["currentEvent", "businessProfile", "currentSubEvent", "currentSession", "currentSpeaker", "userProfile"]),
    speakerStatus() {
      const attendeesSpeakerIds = this.currentEvent.attendees.filter((element) => element.speakerId!==undefined && element.speakerId!==null && element.speakerId!=="").map((e) => e.speakerId);

      if (attendeesSpeakerIds.includes(this.currentSpeaker.speakerId)) {
        return "Joined";
      } else if (!this.currentSpeaker.status) {
        return "Draft";
      }
      return this.currentSpeaker.status;
    },
    isSaveDisabled() {
      if(this.tab == 0) {
        return !(this.isValid(this.currentSpeaker.displayImageURL) && this.isValid(this.currentSpeaker.firstName) && this.isValid(this.currentSpeaker.lastName) && this.isValid(this.currentSpeaker.jobTitle) && this.isValid(this.currentSpeaker.email) && this.isValid(this.currentSpeaker.bio));
      }
      return false;
    },
    breadCrumbItems() {
      if (this.currentEvent && this.currentSpeaker) {
        let items = [
          {
            text: "EventConnect",
            disabled: false,
            routeName: "MultiConnect",
            params: "",
          },
          {
            text: this.currentEvent.name,
            disabled: false,
            routeName: "editMultiConnect",
            params: {eventId: this.eventId},
            query: {tab: 2}
          },
          {
            text: this.currentSubEvent.name,
            disabled: false,
            routeName: "addEditSubEvent",
            params: {eventId: this.eventId, subEventId: this.subEventId},
            query: {tab: 1}
          },
          {
            text: this.currentSession.name,
            disabled: false,
            routeName: "addEditSession",
            query: {
              tab: 1,
            },
            params: {
              eventId: this.eventId,
              subEventId: this.subEventId,
              sessionId: this.sessionId,
            },
          },
          {
            text: this.currentSpeaker.firstName + " " + this.currentSpeaker.lastName,
            disabled: true,
            routeName: "editSpeaker",
            query: {
              tab: 0,
            },
            params: {
              eventId: this.eventId,
              subEventId: this.subEventId,
              sessionId: this.sessionId,
              speakerId: this.currentSpeaker.id,
            },
          }
        ];
        return items;
      } else return [];
    }
  }

}
</script>